import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import HeroVisual from "@/components/HeroVisual";
import { WHY_US } from "@/data/site";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Award, Zap, Server, Globe2, Heart } from "lucide-react";

const whyIcons = [ShieldCheck, Award, Zap, Server, Globe2, Heart];

export default function WhyUs() {
  return (
    <>
      <SEO title="Neden Biz — Pratik Teknoloji" description="Neden Pratik Bilişim Teknolojileri? Güvenilirlik, teknik yetkinlik, hızlı destek, ölçeklenebilir altyapı." />

      <PageHero
        badge="Neden Biz"
        title={<>Kurumsal güç,</>}
        titleAlt="amatör ruh."
        subtitle="Pratik Bilişim Teknolojileri A.Ş. olarak işletmelerin teknoloji altyapılarını güvenilir, sürdürülebilir ve ölçümlenebilir bir yapıya kavuşturmayı hedefliyoruz. Kurumsal standartlarımızı korurken, ilk günden beri taşıdığımız çalışma heyecanını ve amatör ruhumuzu kaybetmeden yanınızda duruyoruz."
        rightSlot={
          <HeroVisual
            accentColor="#FF3B30"
            center={{ logo: "/logos/pt-plus-mark.png", topLabel: "Pratik", bottomLabel: "Teknoloji" }}
            cards={[
              { position: "tr", rotate: 4, delay: 0.4, color: "#FF3B30", icon: <Award size={16} />, label: "Tecrübe", value: "10+", sub: "yıllık teknoloji tutkusu" },
              { position: "ml", rotate: -5, delay: 0.55, color: "#34C759", icon: <Zap size={16} />, label: "Hızlı", value: "30 dk", sub: "ortalama cevap süresi" },
              { position: "br", rotate: 3, delay: 0.7, color: "#007AFF", icon: <ShieldCheck size={16} />, label: "Yetkili", value: "7 marka", sub: "resmi iş ortağı yetkisi" },
            ]}
          />
        }
      />

      <section className="py-16 md:py-24 bg-[#0A0A0A] text-white border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-2 gap-5">
            {WHY_US.map((w, i) => {
              const Icon = whyIcons[i] || ShieldCheck;
              const isLast = i === WHY_US.length - 1;
              return (
                <div
                  key={w.n}
                  data-testid={`why-${w.n}`}
                  className={`group rounded-3xl p-10 border transition-all duration-300 hover:-translate-y-1 ${
                    isLast
                      ? "bg-gradient-to-br from-[#1a1a1a] to-[#0A0A0A] text-white border-[#FF3B30]/40 relative overflow-hidden"
                      : "bg-white/[0.03] border-white/10 hover:border-[#FF3B30]/40 hover:bg-white/[0.06]"
                  }`}
                >
                  {isLast && <div className="absolute -top-16 -right-16 w-64 h-64 bg-[#FF3B30]/20 rounded-full blur-3xl pointer-events-none"></div>}
                  <div className="relative flex items-start gap-6">
                    <div className="flex-none h-14 w-14 rounded-2xl flex items-center justify-center bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30">
                      <Icon size={24} strokeWidth={1.8} />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="font-display text-3xl font-extrabold text-[#FF3B30]">{w.n}</div>
                        <div className="h-px flex-1 bg-white/10"></div>
                      </div>
                      <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-white">{w.title}</h3>
                      <p className="mt-3 text-white/60 leading-relaxed">{w.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-24 md:pb-32 bg-[#0A0A0A] text-center">
        <Link to="/iletisim" className="inline-flex items-center gap-2 rounded-full bg-[#FF3B30] text-white px-7 py-4 font-semibold hover:bg-white hover:text-[#0A0A0A] transition-colors">
          Tanışalım <ArrowRight size={18}/>
        </Link>
      </section>
    </>
  );
}
